import { PkItem } from 'src/features/stock-movements/StockMovementsTypes'
import { PkBatchTable } from '../PkBatchTable'
import { PkModal } from '../PkModal/PkModal'
import * as S from './PkModalSurplus.styles'
import { useState } from 'react'
import ConfirmOrRejectModal from 'src/features/base/components/ConfirmOrRejectModal'
import { useDispatch } from 'react-redux'
import { actions } from 'src/features/stock-movements/StockMovementsState'
import { useSelector } from 'src/utils/store'

interface Props {
  show: boolean
  item: PkItem
  buttonDidNotFitsAction: (item: PkItem) => any
  buttonFitsAction: () => any
  buttonCloseAction: () => any
  testId?: string
}

enum ActionType {
  FITS = 1,
  DID_NOT_FITS = 2
}

export const PkModalSurplus = ({
  show, item, buttonDidNotFitsAction, buttonFitsAction, buttonCloseAction, testId,
}: Props) => {
  const stockMovements = useSelector((state) => state.stockMovements)
  const {
    pkModalDisableButtons,
  } = stockMovements

  const dispatch = useDispatch()

  const color = '#002D62'

  const [showModalConfirmation, setShowModalConfirmation] = useState(false)
  const [actionType, setActionType] = useState<ActionType>()

  const batchesFits = () => {
    setActionType(ActionType.FITS)
    setShowModalConfirmation(true)
  }

  const batchesDidNotFits = () => {
    setActionType(ActionType.DID_NOT_FITS)
    setShowModalConfirmation(true)
  }

  const onConfirm = () => {
    if (pkModalDisableButtons) return

    dispatch(actions.updateMovementsField({ key: 'pkModalDisableButtons', value: true }))
    setShowModalConfirmation(false)
    if (actionType === ActionType.FITS) {
      buttonFitsAction()
    } else if (actionType === ActionType.DID_NOT_FITS) {
      buttonDidNotFitsAction(item)
    }
  }

  return (
    <>
      <ConfirmOrRejectModal
        show={showModalConfirmation}
        title={actionType === ActionType.FITS ? 'EXCEDENTE' : 'NÃO COUBE - EXCEDENTE'}
        headerBackgroundColor={color}
        dataTestId='modal-confirmation'
        customizableDescription={(
          <S.ConfirmModalContainer>
            {actionType === ActionType.FITS
              ? (
                <S.ConfirmModalText>
                  Ao confirmar a ação, você garante que todas as unidades foram devidamente movidas.
                </S.ConfirmModalText>
              )
              : (
                <S.ConfirmModalText>
                  Ao confirmar a ação, <span style={{ fontWeight: 'bold' }}>TODAS</span> as unidades deverão ser movidas para uma nova posição.
                </S.ConfirmModalText>
              )}
            <S.ConfirmModalConfirmationText>
              Deseja prosseguir?
            </S.ConfirmModalConfirmationText>
          </S.ConfirmModalContainer>
        )}
        onClose={() => setShowModalConfirmation(false)}
        onReject={() => setShowModalConfirmation(false)}
        onConfirm={onConfirm}
      />
      <PkModal
        show={show}
        backgroundColor={color}
        title='EXCEDENTE'
        testId={testId}
        body={(
          <S.Container>
            <S.AddressBox color={color}>
              {item.bestPosition.address}
            </S.AddressBox>
            <S.Info color={color}>
              REPONHA O PRODUTO:
            </S.Info>
            <S.ProductInfoBox color={color}>
              {item.productDescription.toUpperCase()}
            </S.ProductInfoBox>
            <S.BatchQuantity color={color}>
              {item.batches.reduce((sum, batch) => sum + batch.quantity, 0)} UNIDADES
            </S.BatchQuantity>
            <PkBatchTable batches={item.batches} color={color} />
          </S.Container>
    )}
        cancelButtonText='Não coube'
        cancelButtonColor='#FF8F1F'
        cancelButtonHoverColor='#BB6815'
        confirmButtonText='Coube tudo'
        confirmButtonColor='#00B578'
        confirmButtonHoverColor='#018055'
        onReject={batchesDidNotFits}
        onConfirm={batchesFits}
        onClose={buttonCloseAction}
      />
    </>
  )
}
